import React from 'react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Phone } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Utilitaires() {
  useSEO('Informations Utiles - ARWM | Ressources Restaurateurs Marrakech', 'Contacts administratifs, réglementations, formations et ressources essentielles pour les professionnels de la restauration à Marrakech.');
  const contacts = [{
    organization: 'Délégation du Tourisme',
    phone: '05244-36131',
    description: 'Informations touristiques et licences'
  }, {
    organization: "Centre Régional d'Investissement (CRI)",
    phone: '05244-20493',
    description: 'Accompagnement des investisseurs'
  }, {
    organization: 'Wilaya de Marrakech',
    phone: '05244-38000',
    description: 'Administration régionale'
  }, {
    organization: "Bureau d'Hygiène",
    phone: '05243-51300',
    description: 'Contrôles sanitaires et autorisations'
  }, {
    organization: 'Protection Civile',
    phone: '15',
    description: 'Urgences et sécurité incendie'
  }, {
    organization: 'Agence Urbaine',
    phone: '05244-38390',
    description: 'Urbanisme et autorisations de construire'
  }];
  return <div className="w-full" data-id="element-562">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-light-gray" data-id="element-563">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-564">
          <h1 className="font-cormorant text-7xl font-bold text-arwm-maroon mb-6" data-id="element-565">
            Informations Utiles
          </h1>
          <p className="font-josefin text-xl text-arwm-dark-text max-w-3xl mx-auto" data-id="element-566">
            Contacts et ressources essentiels pour les professionnels de la
            restauration
          </p>
        </div>
      </section>

      {/* Contacts Table */}
      <section className="py-20 px-4 bg-white" data-id="element-567">
        <div className="max-w-[1280px] mx-auto" data-id="element-568">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-569">
            Contacts Utiles
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-570">
            Contacts Administratifs
          </h2>

          <div className="max-w-5xl mx-auto" data-id="element-571">
            <Table data-id="element-572">
              <TableHeader data-id="element-573">
                <TableRow data-id="element-574">
                  <TableHead className="font-cormorant text-xl font-bold" data-id="element-575">
                    Organisation
                  </TableHead>
                  <TableHead className="font-cormorant text-xl font-bold" data-id="element-576">
                    Téléphone
                  </TableHead>
                  <TableHead className="font-cormorant text-xl font-bold" data-id="element-577">
                    Description
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-578">
                {contacts.map((contact, index) => <TableRow key={index} data-id="element-579">
                    <TableCell className="font-josefin font-semibold text-arwm-dark-text" data-id="element-580">
                      {contact.organization}
                    </TableCell>
                    <TableCell data-id="element-581">
                      <a href={`tel:${contact.phone.replace(/-/g, '')}`} className="flex items-center font-josefin text-arwm-maroon hover:underline" data-id="element-582">
                        <Phone className="w-4 h-4 mr-2" data-id="element-583" />
                        {contact.phone}
                      </a>
                    </TableCell>
                    <TableCell className="font-josefin text-arwm-dark-text" data-id="element-584">
                      {contact.description}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>
      </section>

      {/* Additional Resources */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-585">
        <div className="max-w-[1280px] mx-auto" data-id="element-586">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-587">
            Ressources
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-588">
            Ressources Complémentaires
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-589">
            <div className="bg-white p-8" data-id="element-590">
              <h3 className="font-cormorant text-2xl font-bold text-arwm-maroon mb-4" data-id="element-591">
                Réglementation
              </h3>
              <p className="font-josefin text-arwm-dark-text" data-id="element-592">
                Consultez les dernières réglementations en matière d'hygiène, de
                sécurité et de normes sanitaires.
              </p>
            </div>

            <div className="bg-white p-8" data-id="element-593">
              <h3 className="font-cormorant text-2xl font-bold text-arwm-maroon mb-4" data-id="element-594">
                Formations
              </h3>
              <p className="font-josefin text-arwm-dark-text" data-id="element-595">
                Accédez à notre catalogue de formations professionnelles pour
                vous et vos équipes.
              </p>
            </div>

            <div className="bg-white p-8" data-id="element-596">
              <h3 className="font-cormorant text-2xl font-bold text-arwm-maroon mb-4" data-id="element-597">
                Documentation
              </h3>
              <p className="font-josefin text-arwm-dark-text" data-id="element-598">
                Téléchargez les documents types et modèles utiles pour votre
                activité.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-white" data-id="element-599">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-600">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4" data-id="element-601">
            Nous Contacter
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-6" data-id="element-602">
            Une Question ?
          </h2>
          <p className="font-josefin text-xl text-arwm-dark-text mb-10 max-w-2xl mx-auto" data-id="element-603">
            Notre équipe est à votre disposition pour répondre à toutes vos
            questions
          </p>
          <a href="/contact" className="inline-block px-6 py-4 bg-arwm-maroon text-arwm-cream font-josefin text-sm uppercase tracking-[3.2px] hover:bg-arwm-maroon-dark transition-colors" data-id="element-604">
            Contactez-nous
          </a>
        </div>
      </section>
    </div>;
}